import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "modalpopup" }
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "input-body margin-top-6" }
const _hoisted_11 = ["placeholder", "maxlength", "type", "min", "max"]
const _hoisted_12 = { class: "modal-footer" }
const _hoisted_13 = ["hidden"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValidationSummary = _resolveComponent("ValidationSummary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.localInputModal.Heading ?? ''), 1),
                _createElementVNode("a", {
                  href: "javascript:void(0)",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.Cancel();})
                }, [
                  _createElementVNode("img", { src: _ctx.crossIcon }, null, 8, _hoisted_7)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_ctx.isValidationSummaryVisible)
                  ? (_openBlock(), _createBlock(_component_ValidationSummary, {
                      key: 0,
                      "error-fields": _ctx.validationErrorFields,
                      onCloseClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.CloseValidationSummary($event)))
                    }, null, 8, ["error-fields"]))
                  : _createCommentVNode("", true),
                (_ctx.localInputModal.ModalDescription.length > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "body-content",
                      innerHTML: _ctx.localInputModal.ModalDescription
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.localInputModal.InputValue.$model) = $event)),
                    placeholder: _ctx.localInputModal.Placeholder,
                    maxlength: _ctx.MaxInputLength(),
                    type: _ctx.inputDataType,
                    min: _ctx.DigitsMinimumValue(),
                    max: _ctx.DigitsMaximumValue(),
                    class: "form-control",
                    onKeydown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.BlockInvalidKeys($event)))
                  }, null, 40, _hoisted_11), [
                    [
                      _vModelDynamic,
                      _ctx.v$.localInputModal.InputValue.$model,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary btn-size-default",
                  hidden: _ctx.localInputModal.SecondaryButtonText.length === 0,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.Cancel()))
                }, _toDisplayString(_ctx.localInputModal.SecondaryButtonText ?? ''), 9, _hoisted_13),
                _createElementVNode("button", {
                  class: "btn btn-primary btn-size-default",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.Send(_ctx.v$)))
                }, _toDisplayString(_ctx.localInputModal.PrimaryButtonText ?? ''), 1)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}